import { ComponentType } from 'react';

import { Link } from '../../navigation/link/link.component';
import { MetricTooltip, MetricTooltipProps } from '../metric-tooltip';
import { Chip } from '../chip';
import { Typography, TypographyProps } from '../typography';

export type LinkChipProps = {
  href: string;
  label: string;
  tooltip?: string;
  typographyProps?: TypographyProps;
  tooltipPlacement?: MetricTooltipProps['placement'];
  chipIcon?: ComponentType;
};

export const LinkChip = ({
  href,
  label,
  tooltip,
  typographyProps,
  tooltipPlacement,
  chipIcon: Icon,
}: LinkChipProps) => {
  const content = (
    <Link href={href} target='_blank' rel='noopener noreferrer' maxWidth='100%'>
      <Chip
        label={
          <Typography
            sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            component='span'
            variant='inherit'
            {...typographyProps}
          >
            {label}
          </Typography>
        }
        component='span'
        clickable
        icon={Icon ? <Icon /> : undefined}
      />
    </Link>
  );

  if (tooltip === '') {
    return content;
  }

  return (
    <MetricTooltip title={tooltip || label} placement={tooltipPlacement || 'top'}>
      {content}
    </MetricTooltip>
  );
};
